const LOGO_URL =
  "https://static.readdy.ai/image/a07a911c26a50ba40c2df7c423ae5027/60f09cc48ebab0b35cac7795610072c5.jpeg";

export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-[#030811] border-t border-[#D4AF37]/10 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-14">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 rounded-lg overflow-hidden border border-[#D4AF37]/40">
                <img src={LOGO_URL} alt="Web2Revenue Logo" className="w-full h-full object-cover" />
              </div>
              <span className="text-white font-bold text-lg tracking-widest" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                WEB<span className="text-[#D4AF37]">2</span>REVENUE
              </span>
            </div>
            <p className="text-white/40 text-sm leading-relaxed max-w-xs" style={{ fontFamily: "'Inter', sans-serif" }}>
              Turning local businesses into digital revenue machines through modern, high-converting websites.
            </p>
            <div className="flex items-center gap-4 mt-6">
              {[
                { icon: "ri-instagram-line", href: "https://instagram.com/web2revenue" },
                { icon: "ri-tiktok-line", href: "https://tiktok.com/@web2revenue" },
                { icon: "ri-whatsapp-line", href: "https://wa.me/13055551234" },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-[#D4AF37]/20 text-[#D4AF37]/60 hover:text-[#D4AF37] hover:border-[#D4AF37]/60 transition-all duration-300 cursor-pointer"
                >
                  <i className={`${s.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold text-sm tracking-widest uppercase mb-5" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Quick Links
            </h4>
            <ul className="flex flex-col gap-3">
              {[
                { label: "Services", id: "services" },
                { label: "Portfolio", id: "portfolio" },
                { label: "Why Us", id: "why-us" },
                { label: "Contact", id: "cta" },
              ].map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollTo(link.id)}
                    className="text-white/40 hover:text-[#D4AF37] text-sm transition-colors duration-300 cursor-pointer text-left"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold text-sm tracking-widest uppercase mb-5" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Contact
            </h4>
            <div className="flex flex-col gap-4">
              <div className="flex items-center gap-3">
                <i className="ri-map-pin-line text-[#D4AF37] text-base" />
                <span className="text-white/40 text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>Miami, Florida & Online</span>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-tiktok-line text-[#D4AF37] text-base" />
                <span className="text-white/40 text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>@web2revenue</span>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-whatsapp-line text-[#D4AF37] text-base" />
                <span className="text-white/40 text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>Available via WhatsApp</span>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-[#D4AF37]/10 mb-8" />

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/25 text-xs" style={{ fontFamily: "'Inter', sans-serif" }}>
            &copy; 2025 Web2Revenue. All rights reserved. Miami, FL.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-white/25 hover:text-[#D4AF37]/60 text-xs transition-colors duration-300 cursor-pointer" style={{ fontFamily: "'Inter', sans-serif" }} rel="nofollow">
              Privacy Policy
            </a>
            <div className="w-1 h-1 rounded-full bg-[#D4AF37]/30" />
            <a href="#" className="text-white/25 hover:text-[#D4AF37]/60 text-xs transition-colors duration-300 cursor-pointer" style={{ fontFamily: "'Inter', sans-serif" }} rel="nofollow">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
